export default __webpack_public_path__ + "static/media/PALM_BEACH_POST.7112329e.png";